import { ventures, images } from "../content/site";
import { FadeUp, StaggerGroup, StaggerItem } from "./Reveal";

export default function Business() {
  return (
    <section
      id="ventures"
      data-testid="section-ventures"
      className="relative overflow-hidden bg-ink py-28 text-cream sm:py-36"
    >
      {/* faint architectural backdrop */}
      <div className="pointer-events-none absolute inset-0 opacity-15">
        <img src={images.venturesBg} alt="" className="h-full w-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-ink/70" />
      </div>

      <div className="container-edge relative z-10">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <FadeUp delay={0.05}>
              <h2 className="font-serif text-4xl leading-[1.04] tracking-tight sm:text-5xl lg:text-6xl">
                {ventures.headline}
              </h2>
            </FadeUp>
          </div>
          <div className="lg:col-span-5">
            <FadeUp delay={0.1}>
              <p className="font-sans text-base font-light leading-relaxed text-cream/70">
                {ventures.body}
              </p>
            </FadeUp>
          </div>
        </div>

        <StaggerGroup className="mt-20 grid grid-cols-2 gap-px border border-cream/12 md:grid-cols-4">
          {ventures.stats.map((s) => (
            <StaggerItem
              key={s.label}
              className="border border-cream/12 bg-white/[0.02] p-8"
            >
              <p className="font-sans text-[10px] uppercase tracking-overline text-cream/40">{s.label}</p>
              <p className="mt-6 font-serif text-3xl tracking-tight text-cream sm:text-4xl">
                {s.value}
                {s.unit && <span className="ml-2 font-sans text-sm font-light text-brass">{s.unit}</span>}
              </p>
              {s.note && (
                <p className="mt-3 font-sans text-xs font-light italic text-cream/40">{s.note}</p>
              )}
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
